import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useForm } from "../../../../../hooks/useForm";
import { AppContext } from "../../../Context/Context";
import { ItemsBloqueHome } from "../../home/bloques/ItemsBloqueHome";
import PasswordInput from "../../auth/PasswordInput";

export const Login = () => {
    const [environment, setEnvironment] = useState("");
    const [state, setState] = useContext(AppContext);
    const [token, setToken] = useState(null);

    const captchaRef = useRef(null);
    const history = useHistory();

    const [formValues, handleInputChange, reset] = useForm({
        documento: "",
        password: ""
    });

    const { documento, password } = formValues;

    const [errorDocument, setErrorDocument] = useState("");
    const [errorPassword, setErrorPassword] = useState("");

    /* =========================
       INIT
    ========================= */

    useEffect(() => {
        fetchEnvironment();
        fetchToken();
        renderCaptcha();
    }, []);

    const fetchEnvironment = async () => {
        const res = await fetch("/api/get_enviroment");
        const json = await res.json();
        setEnvironment(json.environment);
    };

    const fetchToken = async () => {
        const timestamp = new Date().getTime();
        const endpoint = await (await fetch("/api/show_endpoints/wsvalidakey")).json();

        const res = await fetch(
            `${endpoint.url_base}${endpoint.url_variable}?Key=7b7e11bebe768ede59c3ea9363a70c06&timestamp=${timestamp}`,
            { cache: "no-cache" }
        );

        const json = await res.json();
        setToken(json);
    };

    const renderCaptcha = () => {
        const interval = setInterval(() => {
            if (window.grecaptcha && captchaRef.current) {
                window.grecaptcha.render(captchaRef.current, {
                    sitekey: "6LdiJW0kAAAAAOM-l-2ZezB9qvaIkq8-F3Q5xN7L"
                });
                clearInterval(interval);
            }
        }, 300);
    };

    /* =========================
       SUBMIT
    ========================= */

    const handleSubmit = async (e) => {
        e.preventDefault();

        /* ===== Validación documento ===== */
        const onlyNumbers = /^[0-9]+$/.test(documento);

        if (!onlyNumbers || documento.length < 8) {
            setErrorDocument("Debe tener solo números y al menos 8 cifras");
            return;
        } else {
            setErrorDocument("");
        }

        /* ===== Validación password ===== */
        if (password.length < 8 || password.length > 15) {
            setErrorPassword("Contraseña inválida");
            return;
        } else {
            setErrorPassword("");
        }

        /* ===== Validación captcha ===== */
        const captchaResponse = window.grecaptcha.getResponse();

        if (!captchaResponse) {
            Swal.fire({
                icon: "error",
                title: "Captcha requerido",
                text: "Por favor valide el captcha"
            });
            return;
        }

        if (environment !== "dev") {
            const captchaCheck = await fetch(`/validate-captcha/${captchaResponse}`);
            const captchaJson = await captchaCheck.json();

            if (!captchaJson.success) {
                window.grecaptcha.reset();
                Swal.fire({
                    icon: "error",
                    title: "Captcha inválido",
                    text: "Reintente"
                });
                return;
            }
        }

        /* ===== Login ===== */
        Swal.fire({
            title: "Iniciando sesión",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => Swal.showLoading()
        });

        try {
            const timestamp = new Date().getTime();

            const hashEndpoint = await (await fetch("/api/show_endpoints/wshasheatexto")).json();
            const hashRes = await fetch(
                `${hashEndpoint.url_base}${hashEndpoint.url_variable}?Password=${password}&timestamp=${timestamp}`
            );

            const hashJson = await hashRes.json();

            const loginEndpoint = await (await fetch("/api/show_endpoints/wsingresar")).json();
            const loginRes = await fetch(
                `${loginEndpoint.url_base}${loginEndpoint.url_variable}?Token=${token.Token.Token}&CUIT=${documento}&Password=${hashJson.Hash}&timestamp=${timestamp}`,
                { cache: "no-cache" }
            );

            const loginJson = await loginRes.json();

            if (!Object.keys(loginJson).length) {
                history.push("/login_mi_plan");
                return;
            }

            const errorCode =
                loginJson.Login?.ErrorCodigo ??
                loginJson.ErrorCodigo ??
                null;

            /* ===== LOGIN OK ===== */
            if (errorCode === "00") {
                Swal.close();

                const endpoint = await (await fetch("/api/show_endpoints/wsmisplanes")).json();
                const brand = await (await fetch("/api/get_brand")).json();

                const planesRes = await fetch(
                    `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&Brand=${brand.nombre}&TokenLogin=${loginJson.Login.TokenLogin}&timestamp=${timestamp}`,
                    { cache: "no-cache" }
                );

                const planesJson = await planesRes.json();
                setState({ ...state, data: planesJson });

                sessionStorage.setItem("dtdc", btoa(documento));
                sessionStorage.setItem("dttk", btoa(loginJson.Login.TokenLogin));
                sessionStorage.setItem("dtvalid", btoa(true));

                history.push("/seleccion_plan");
                return;
            }

            /* ===== ERRORES AGRUPADOS ===== */
            if (
                errorCode === "01" ||
                errorCode === "02" ||
                errorCode === "02/01" ||
                errorCode === "02/02" ||
                errorCode === "02/03" ||
                errorCode === "02/04"
            ) {
                handleLoginError("Error", "Reintente");
                return;
            }

            if (errorCode === "03") {
                handleLoginError(
                    "El usuario está dado de baja",
                    "Consulte con el proveedor del servicio"
                );
                return;
            }

            if (errorCode === "04") {
                handleLoginError(
                    "La contraseña no está generada",
                    "Consulte el enlace crear nuevo usuario"
                );
                return;
            }

            if (errorCode === "05") {
                handleLoginError(
                    "La contraseña es incorrecta",
                    "Intenta nuevamente o cambia tu clave en ¿Olvidaste tu Contraseña?"
                );
                return;
            }

            if (errorCode === "06") {
                handleLoginError(
                    "No existe usuario",
                    "Consulte con el proveedor del servicio"
                );
                return;
            }

            if (errorCode === "07") {
                handleLoginError(
                    "Usuario Bloqueado",
                    "Para desbloquear use '¿Usuario Bloqueado?'"
                );
                return;
            }

            /* ===== FALLBACK ===== */
            handleLoginError("Error", "Intente nuevamente");

        } catch (err) {
            Swal.close();
            window.grecaptcha.reset();
            reset();

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Intente nuevamente"
            });
        }
    };

    const handleLoginError = (title, text) => {
        Swal.close();
        window.grecaptcha.reset();
        reset();

        Swal.fire({
            icon: "error",
            title: title,
            text: text
        });
    };

    /* =========================
       UI
    ========================= */

    return (
        <div className="login">
            <div className="login_title">
                <h1>Iniciar sesión</h1>
            </div>

            <div className="login_formDiv">
                <div className="login_formDiv--desktop">
                    <div className="login_formDiv--desktop--form">
                        <form className="login_form" onSubmit={handleSubmit}>
                            <h1>INICIAR SESIÓN</h1>

                            <input
                                autoComplete="off"
                                className={`login_form--input ${errorDocument ? "errorInput" : ""}`}
                                placeholder="CUIT / CUIL"
                                name="documento"
                                value={documento}
                                onChange={handleInputChange}
                            />

                            <p className={errorDocument ? "errorMsgInput" : ""}>
                                {errorDocument}
                            </p>

                            <PasswordInput
                                name="password"
                                value={password}
                                placeholder="Contraseña"
                                onChange={handleInputChange}
                                minLength={8}
                            />

                            <p className={errorPassword ? "errorMsgInput" : ""}>
                                {errorPassword}
                            </p>

                            <div
                                id="captcha_id"
                                ref={captchaRef}
                                className="g-recaptcha"
                                style={{ marginTop: "35px" }}
                            />

                            <button className="login_form--button m-base" type="submit">
                                <p>Ingresar</p>
                            </button>

                            <input type="hidden" name="username" value={documento} />
                            <input type="hidden" name="bm-telemetry" id="bm-telemetry" />
                        </form>

                        <div className="login_links">
                            <Link to="/nuevo_usuario">Crear usuario nuevo</Link>
                            <Link to="/recuperar_contrasena">
                                ¿Olvidaste tu Contraseña?
                            </Link>
                            <Link to="/desbloquear_usuario">
                                ¿Usuario Bloqueado?
                            </Link>
                        </div>
                    </div>

                    <div className="login_atencion">
                        <div className="separator--hor mt-half mb-half"></div>
                        <ItemsBloqueHome
                            logo="/images/icons/atencion-al-cliente.svg"
                            texto="ATENCIÓN AL CLIENTE"
                            href="https://crmfcalatam.my.site.com/selfservicepda/s/jeep"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
